import { useState, useEffect } from 'react';
import { getValue, fetchAndActivate } from 'firebase/remote-config';

import { useRemoteConfig } from '~/hooks/useRemoteConfig';
import { Line } from './line';
import { useLineController } from '~/hooks/useLineController';
import { useRouter } from 'next/router';
import { Loading } from '~/components/Loading';
import NotFound from '~/components/404';
import { ModalQrCodeDisabled } from '~/components/ModalQrCodeDisabled';

const Controller = () => {
  const { loading, error, unitData, qrCodeSettingsData } = useLineController();
  const router = useRouter();
  const [isGenericQrCode, setIsGenericQrCode] = useState<boolean | null>(null);
  const [canSeeBirthDateField, setCanSeeBirthDateField] = useState<
    boolean | null
  >(null);
  const [canSeeEmailField, setCanSeeEmailField] = useState<boolean>(true);
  const remoteConfig = useRemoteConfig({
    qr_code_line_generic: JSON.stringify({ unity_id: [] }),
  });

  useEffect(() => {
    if (!unitData?.id) return;

    remoteConfig.then((value) => {
      if (value) {
        fetchAndActivate(value)
          .then(() => {
            const qrCodeGenericValue = getValue(
              value,
              'qr_code_line_generic'
            ).asString();
            const birthDateFieldValue = getValue(
              value,
              'birth_date_visible_line'
            ).asString();
            const hiddenEmailFieldValue = getValue(
              value,
              'email_hidden_line'
            ).asString();

            const listUnitsQrCodeGeneric: string[] =
              JSON.parse(qrCodeGenericValue).unity_id;
            const listUnitsBirthDateField: string[] =
              JSON.parse(birthDateFieldValue).unit_id;
            const unitListWithHiddenEmailField: string[] = JSON.parse(
              hiddenEmailFieldValue
            ).unit_id;

            setIsGenericQrCode(listUnitsQrCodeGeneric.includes(unitData.id));
            setCanSeeBirthDateField(
              listUnitsBirthDateField.includes(unitData.id)
            );
            setCanSeeEmailField(
              !unitListWithHiddenEmailField.includes(unitData.id)
            );
          })
          .catch(() => setIsGenericQrCode(false));
      } else {
        setIsGenericQrCode(false);
      }
    });
  }, [unitData?.id, remoteConfig]);

  if (!router.isReady || loading) {
    return <Loading />;
  }

  if (error) {
    return <NotFound />;
  }

  if (!unitData || !qrCodeSettingsData) {
    return <Loading />;
  }

  if (qrCodeSettingsData.qr_code_enabled === false) {
    return <ModalQrCodeDisabled />;
  }

  return (
    <Line
      qrCodeSettingsData={qrCodeSettingsData}
      unitData={unitData}
      isQrCodeGeneric={isGenericQrCode}
      canSeeBirthDateField={canSeeBirthDateField}
      canSeeEmailField={canSeeEmailField}
    />
  );
};

export default Controller;
